import { useAuth } from '@clerk/react'
import { useCallback } from 'react'
import { env } from '../env'

export type GetToken = () => Promise<string | null>

/**
 * API 호출용 토큰 getter. 평소엔 Clerk 세션 토큰.
 * VITE_E2E_TOKEN 이 있으면(Playwright · 로컬 전용) ClerkProvider 없이 그 값을 Bearer 로 쓴다 —
 * API 는 ENVIRONMENT=local 일 때만 이 토큰을 인정하므로 dev·production 빌드에 섞여도 통과하지 못한다.
 * 어느 쪽을 쓸지는 빌드 시점 상수라 훅 호출 순서가 바뀌지 않는다.
 */
function useClerkToken(): GetToken {
  return useAuth().getToken
}
function useE2EToken(): GetToken {
  return useCallback(() => Promise.resolve(env.E2E_TOKEN ?? null), [])
}
export const useGetToken: () => GetToken = env.E2E_TOKEN ? useE2EToken : useClerkToken

function useClerkSessionKey(): string | null {
  return useAuth().sessionId ?? null
}
/** Request lifetime only; never logged, sent as a new credential, or used for authorization. */
export const useAdminSessionKey: () => string | null = env.E2E_TOKEN
  ? () => 'local-e2e'
  : useClerkSessionKey
